<template>
  <div class="map-wrap">
    <div ref="mapRef" class="map-box"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import chinaJson from '@/assets/china.json'
export default {
  name: 'FootprintMap',
  props: {
    footData: {
      type: Array,
      default: () => []
    },
    isSummaryView: {
      type: Boolean,
      default: false
    },
    groupType: {
      type: String,
      default: 'lover'
    },
    groupList: {
      type: Array,
      default: () => []
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isPoster: { type: Boolean, default: false } 
  },
    provinceStat: {
    type: Object,
    default: null
  
  },
  data() {
    const fullToShortMap = {
      '广西壮族自治区': '广西',
      '宁夏回族自治区': '宁夏',
      '香港特别行政区': '香港',
      '澳门特别行政区': '澳门',
      '内蒙古自治区': '内蒙古',
      '西藏自治区': '西藏',
      '新疆维吾尔自治区': '新疆',
      '海南省': '海南'
    }
    // 一次性生成反向映射，不再每次tooltip都循环生成
    const shortToFullMap = Object.fromEntries(
      Object.entries(fullToShortMap).map(([k, v]) => [v, k])
    )
    return {
      chart: null,
      myVisitedProvinces: [],
      resizeTimer: null,
      fullToShortMap,
      shortToFullMap
    }
  },
  watch: {
    footData: {
      handler(newVal) {
        this.parseProvinceList()
        this.$nextTick(() => {
          this.renderMapOnly()
        })
      },
      deep: true,
      immediate: true
    },
    groupType() {
      this.$nextTick(() => {
        this.renderMapOnly()
      })
    },
    isLogin() {
      this.parseProvinceList()
      this.$nextTick(() => {
        this.renderMapOnly()
      })
    },
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    if (this.resizeTimer) clearTimeout(this.resizeTimer)
    // 解绑echart点击事件，避免多次绑定
    if (this.chart) {
      this.chart.off('click')
      this.chart.dispose()
      this.chart = null
    }
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    parseProvinceList() {
      const provinceSet = new Set()
      this.footData.forEach(item => {
        if (!item.province) return
        let rawProvince = item.province.trim()
        provinceSet.add(rawProvince)
      })
      this.myVisitedProvinces = Array.from(provinceSet)
    },

   getTooltipText(params) {
  if (!params?.name) return ''
  const provinceName = params.name
  const matchFullName = this.shortToFullMap[provinceName] || provinceName

  // 【新增分支：统计页面传入provinceStat时，直接使用父组件预计算结果，不再自己循环】
  if (this.provinceStat && this.provinceStat[matchFullName]) {
    const info = this.provinceStat[matchFullName]
    let html = `${provinceName}<br/>总计：${info.total}次`
    if (info.personal > 0) {
      html += `<br/>个人：${info.personal}次`
    }
    if (info.group > 0) {
      html += `<br/>小组：${info.group}次`
    }
    return html
  }

  // ========== 下面【原有首页逻辑，完全原样保留，一行不改！】 ==========
  const provinceItems = this.footData.filter(d => {
    const p = d.province?.trim()
    return p === matchFullName || p === provinceName
  })

  if (!provinceItems.length) {
    return `${provinceName}<br/>暂无足迹`
  }

  let personalCount = 0
  let groupCount = 0
  provinceItems.forEach(item => {
    if (item.belongGroupId === "") {
      personalCount++
    } else {
      groupCount++
    }
  })

  let html = `${provinceName}<br/>总计：${provinceItems.length}次`
  if (personalCount > 0) {
    html += `<br/>个人：${personalCount}次`
  }
  if (groupCount > 0) {
    html += `<br/>小组：${groupCount}次`
  }
  return html
},

    getZoomLevel() {
     if (this.isPoster) return 1.55;
      // 计算屏幕宽高比
      const ratio = window.innerWidth / window.innerHeight;
      if (ratio < 1.2) {
        return 1.0; 
      }
      if (ratio < 1.52) {
        return 1.2;
      }
      return 1.55;
    },

    getMapOption() {
      const normalColor = '#e6e6e6'
      let highlightShadow
      if (this.groupType === 'lover') {
        highlightShadow = 'rgba(214, 72, 107, 0.35)'
      } else if (this.groupType === 'parent') {
        highlightShadow = 'rgba(35, 153, 87, 0.35)'
      } else if (this.groupType === 'child') {
        highlightShadow = 'rgba(43, 124, 223, 0.35)'
      } else if (this.groupType === 'other') {
        highlightShadow = 'rgba(136, 102, 221, 0.35)'
      } else if (this.groupType === 'personal') {
        highlightShadow = 'rgba(30, 114, 208, 0.35)'
      } else {
        highlightShadow = 'rgba(214, 72, 107, 0.35)'
      }
      let visitData = []
      if (this.isLogin) {
        visitData = this.myVisitedProvinces.map(name => {
          return { name, value: 1 }
        })
      } else {
        visitData = [
          {
            name: '重庆市',
            itemStyle: {
              areaColor: '#2f8cff',
              borderColor: '#1d5fd1',
              borderWidth: 1
            }
          },
          {
            name: '山东省',
            itemStyle: {
              areaColor: '#ff4d4f',
              borderColor: '#cf1322',
              borderWidth: 1
            }
          }
        ]
      }
      return {
        tooltip: {
          show: true,
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.95)',
          textStyle: { color: '#333' },
          borderColor: 'rgba(0,0,0,0.08)',
          borderWidth: 1,
          borderRadius: 8,
          padding: 10,
          formatter: (params) => this.getTooltipText(params)
        },
        visualMap: {
          show: false,
          min: 0,
          max: 1,
          inRange: {
            color: [normalColor, this.getThemeColor()]
          }
        },
        animationType: 'scale',
        animationEasing: 'elasticOut',
        animationDelayUpdate: 200,
        series: [
          {
            type: 'map',
            map: 'china',
            roam: false,
            zoom: this.getZoomLevel(),
            layoutCenter: this.isPoster 
              ? ['57%', '72%'] 
              : ((window.innerWidth / window.innerHeight) < 1.52 ? ['62%', '62%'] : ['64%', '69%']),
            layoutSize: this.isPoster ? '90%' : '84%',
            label: {
              show: true,
              fontSize: this.isPoster ? 8 : 10,
              color: '#333',
              textShadowColor: 'rgba(255,255,255,0.95)',
              textShadowBlur: 4,
              textBorderColor: this.isPoster ? 'transparent' : 'rgba(255,255,255,0.8)',
              textBorderWidth: this.isPoster ? 0 : 1.2,
              formatter: function (params) {
                const nameMap = {
                  '香港特别行政区': '香港',
                  '澳门特别行政区': '澳门',
                  '宁夏回族自治区': '宁夏',
                  '广西壮族自治区': '广西'
                }
                return nameMap[params.name] || params.name
              }
            },
            itemStyle: {
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.9,
                colorStops: [
                  { offset: 0, color: '#f7f8fa' },
                  { offset: 1, color: '#eef1f5' }
                ]
              },
              borderColor: '#c2c9d6',
              borderWidth: 0.75,
              shadowBlur: 14,
              shadowColor: 'rgba(0, 0, 0, 0.24)',
              shadowOffsetX: 2,
              shadowOffsetY: 4
            },
            emphasis: {
              itemStyle: {
                borderColor: 'rgba(255,255,255,0.95)',
                borderWidth: 2,
                shadowBlur: 18,
                shadowColor: highlightShadow,
                shadowOffsetX: 0,
                shadowOffsetY: 6
              },
              label: {
                fontWeight: 'bold',
                color: '#222222'
              }
            },
            data: [
              ...visitData
            ]
          }
        ]
      }
    },
    getThemeColor() {
      if (this.groupType === 'lover') return '#ff748c'
      if (this.groupType === 'parent') return '#32b070'
      if (this.groupType === 'child') return '#4298f5'
      if (this.groupType === 'other') return '#8866dd'
      if (this.groupType === 'personal') return '#1e72d0'
      return '#ff748c'
    },
    renderMapOnly() {
      if (!this.chart) return
      const option = this.getMapOption()
      this.chart.setOption(option, true)
    },
    initMap() {
      this.chart = echarts.init(this.$refs.mapRef)
      const mapData = JSON.parse(JSON.stringify(chinaJson))
      const cpMap = {
        "北京市": [116.40, 39.95],
        "天津市": [118.30, 39.10],
        "河北省": [115.50, 38.20],
        "上海市": [121.48, 31.30],
        "内蒙古自治区": [110.50, 41.20],
        "甘肃省": [103.82, 36.06],
        "香港特别行政区": [116.05, 22.20],
        "澳门特别行政区": [113.55, 21.50]
      }
      mapData.features.forEach(feature => {
        const name = feature.properties.name
        if (cpMap[name]) {
          feature.properties.cp = cpMap[name]
        }
      })
      echarts.registerMap('china', mapData)
      const option = this.getMapOption()
      this.chart.setOption(option, true)

      // 点击回调 原样保留：南海诸岛→海南省，海南→海南省
      this.chart.on('click', (params) => {
        if (!params?.name) return
        if (params.name === '南海诸岛') {
          if (!this.isLogin) return
          this.$emit('province-click', { name: '海南省', view: 'nanhai' })
        }
        else if (params.name === '海南') {
          this.$emit('province-click', '海南省')
        }
        else {
          this.$emit('province-click', params.name)
        }
      })

      this.resizeHandler = () => {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => {
          if (this.chart) {
            this.chart.resize()
            // 👇 在窗口大小改变后，重新刷一下 option 里的 zoom
            const newOption = this.getMapOption(); 
            this.chart.setOption(newOption, true);
          }
        }, 120)
      }
      window.addEventListener('resize', this.resizeHandler)
    }
  }
}
</script>

<style scoped>
.map-wrap {
  position: relative;
  width:100%;
  height:100%;
}
.map-box {
  width:100%;
  height:100%;
  overflow: hidden;
}
</style>